import React, { useState, useEffect } from 'react';
import api from '../FetchComponents/FetchComponentsServices';
import { Loader } from "@progress/kendo-react-indicators";
import RemoveStagingRecordModal from './RemoveStagingRecordModal'
import "../Shared/Xref.css"

const StagingTable = ({ }) => {
    const [Loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [dataLength, setDataLength] = useState(0);
    const [error, setError] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState({ osUidmId: '' });
    const [message, setMessage] = useState('');

    const OnDelete = (record) => {
        setSelectedRecord(record)
        setShowDeleteModal(true)
    }

    const DeleteRecord = async () => {
        try {
          await api.RemoveFromStagingTable(selectedRecord.osUidmId)
          setShowDeleteModal(false)
          fetchData()
        } catch (error) {
          // Handle error
          console.error('Error deleting new Admin:', error.message);
        }
    }

    const renderRecordRow = (record, index) => {
        const even = (index % 2 == 0)
        return <tr key={index + 1} className={even ? 'even' : 'odd'}>
          <td>{record.osUidmId}</td>
          <td>{record.lastMessageSent}</td>
          <td>{record.osUbuckIDLastModifiedTime}</td>
          <td>
            <button onClick={() => OnDelete(record)} aria-label={`Remove ${record.osUidmId}`} className='k-button-solid-primary k-button-sm delete-btn'>Remove</button>
          </td>
        </tr>
    }

    const fetchData = async () => {
        try {
            const result = await api.GetStagingTable()
            const recordsWithMessages = []
            const recordsWithoutMessages = []
            setLoading(true)
            result.forEach(record => {
                if(record.lastMessageSent) {
                    recordsWithMessages.push(record)
                } else {
                    recordsWithoutMessages.push(record)
                }
            });

            recordsWithMessages.sort((a, b) => new Date(b.lastMessageSent) - new Date(a.lastMessageSent));
            recordsWithoutMessages.sort((a, b) => new Date(b.osUbuckIDLastModifiedTime) - new Date(a.osUbuckIDLastModifiedTime));

            setData([...recordsWithoutMessages, ...recordsWithMessages]);
            setDataLength(result.length)
            setLoading(false)
        } catch(e) {
            setError(true);
            setMessage(e.message);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <h1 className="page-title">Staging Table Data</h1>
            {error && <h2>{message}</h2>}
            {Loading && (
                <h2>
                    <Loader className="spinner-small" size="small" type="infinite-spinner" />
                    <em> Loading Data...</em>
                </h2>
            )}
            {!error && dataLength === 0 && (
                <h2>No records found</h2>
            )}
            {!error && dataLength > 0 && (
                <>
                    <h2>{dataLength} records found</h2>
                    <table className='table-striped' aria-labelledby="tabelLabel">
                        <thead>
                            <tr className='odd'>
                                <th>OSU Idm Id</th>
                                <th>Last Message Sent</th>
                                <th>OSU BuckID LastModified Time</th>
                                <th>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((record, index) => renderRecordRow(record, index))}
                        </tbody>
                    </table>

                    {showDeleteModal && (
                        <RemoveStagingRecordModal
                            record={selectedRecord}
                            onDelete={DeleteRecord}
                            onCancel={() => setShowDeleteModal(false)}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default StagingTable;